import React from 'react';

import Left from './Left';
import { Right } from './Right';


import './index.css';

import './script.js';

export default function App() {
  return (
    <main>




      <div id="content">

        <Left></Left>
        <Right></Right>




      </div>


      <div className="footer">


        Made by Jason Keo. All rights reserved. © <a href="https://github.com/jasonkeo/website">Source Code</a>

      </div>
    </main>



  );
}


